import React, { useRef } from "react";
import { useReactToPrint } from "react-to-print";
import "../../../styles/admins/invoices/invoice.css";
import { useNavigate } from "react-router-dom";
import convertAmountToWords from "../../confs/amount_words";
import emailjs from "@emailjs/browser";



const rowOne = { width: "7%", textAlign: "center" };
const rowTwo = { width: "46%" };
const rowThree = { width: "20%" };
const rowFour = { borderRight: "none", width: "20%", textAlign: "right" };

function InvoicePage(props) {
  console.log(props);
  const contentRef = useRef();
  const navigate = useNavigate();
  const reactToPrintFn = useReactToPrint({
    contentRef,
    onAfterPrint: () => {
      setTimeout(() => {
        if (props.isReprint) {
          navigate(-1);
        } else {
          props.toggleHeader();
          localStorage.removeItem("rooms");
          localStorage.removeItem(
            `food_order_${props.invoiceDetails.booking_id}`
          );
          navigate("/admin/rooms", { replace: true });
        }
      }, 400);
    },
  });


    const hotelDetail = props.clientDetails;
console.log(hotelDetail);

  window.onpopstate = (e) => {
    localStorage.removeItem("rooms");
    window.location.reload();
  };

  const clientIs = localStorage.getItem("client_is");
  const clientDetails = JSON.parse(clientIs);

  const guests = JSON.parse(localStorage.getItem("guests"));
  const rooms = JSON.parse(localStorage.getItem("rooms"));

  const getRoomTypeById = (id) => {
    if (!rooms || !Array.isArray(rooms)) return "PREMIUM";
    const room = rooms.find((r) => r.room_id === id);
    return room ? room.room_type : "PREMIUM";
  };

  // Function to get guest details by guestId
  const getGuestDetails = (guestId) => {
    const guest = guests.find((g) => g.id === guestId);
    if (guest) {
      if (guest.is_com) {
        guest.name = JSON.parse(props.invoiceDetails.guest_data).name[0];
        var guestName = "";
        const Gname = guest.name.split(",");
        if (Gname.length > 1) {
          guestName = Gname[1];
          for (let i = 2; i < Gname.length; i++) {
            guestName = guestName + "," + Gname[i];
          }
        }
        return {
          name: Gname[0],
          guest_name: guestName,
          contact: guest.contact,
          comp_contact: guest.comp_contact ?? "",
          address: guest.address,
          is_com: guest.is_com,
        };
      } else {
        return {
          name: guest.name,
          contact: guest.contact,
          address: guest.address,
          is_com: guest.is_com,
        };
      }
    } else {
      return {
        name: JSON.parse(props.invoiceDetails.guest_data).name[0],
        contact: "",
      };
    }
  };

  const guestData = getGuestDetails(
    JSON.parse(props.invoiceDetails.guest_data).id[0]
  );


  const calculateDaysDifference = (from, to) => {
    if (!from || !to) return 0;
    const fromDate = new Date(from);
    const toDate = new Date(to);
    const timeDifference = toDate - fromDate;
    return Math.ceil(timeDifference / (1000 * 60 * 60 * 24));
  };

  // const sumof = (arr) => {
  //   return arr.reduce((acc, curr) => acc + parseFloat(curr), 0);
  // };

  const sendInvoiceEmail = async () => {
  // Ask for email
  const recipientEmail = prompt("Enter recipient email:");
  if (!recipientEmail) return alert("Email is required!");

  try {;

const templateParams = {
  guest_email: recipientEmail,
  guest_name: guestData.name,
  business_name: props.clientDetails.business_name,
  business_address: props.clientDetails.address,
  business_contact: props.clientDetails.contact,
  invoice_no: props.invoiceDetails.inv_no,
  room_no: props.multiBills && props.multiBills.length > 1
    ? props.multiBills.map((b) => b.room_no).join(", ")
    : props.invoiceDetails.room_no,
  check_in: `${props.invoiceDetails.from_date.slice(8, 10)}-${props.invoiceDetails.from_date.slice(5, 7)}-${props.invoiceDetails.from_date.slice(0, 4)} ${props.invoiceDetails.from_date.slice(11, 16)}`,
  check_out: `${props.invoiceDetails.to_date.slice(8, 10)}-${props.invoiceDetails.to_date.slice(5, 7)}-${props.invoiceDetails.to_date.slice(0, 4)} ${props.invoiceDetails.to_date.slice(11, 16)}`,
  total_amount: (
    parseFloat(props.invoiceDetails.total_amount) -
    parseFloat(props.invoiceDetails.discount) +
    (props.printExtra ? parseFloat(props.invoiceDetails.extra_charges) : 0) +
    (props.printFood ? parseFloat(props.invoiceDetails.food_price) : 0) +
    (props.printFood ? parseFloat(props.invoiceDetails.food_tax_amount) : 0) +
    parseFloat(props.invoiceDetails.tax_amount)
  ).toFixed(0),
  tnc: props.clientDetails.footer_contents
};


    // Send email
    const result = await emailjs.send(
      "service_hotel",
      "template_invmail",
      templateParams,
      "KmLMyafHuXZau644u"
    );

    alert("Invoice sent successfully!");
    console.log(result);
  } catch (error) {
    console.error("Error sending email:", error);
    alert("Failed to send invoice. Check console for details.");
  }
};


  return (
    <section className="d-flex flex-column align-items-center">
      <div
        className="invoice-outer col-lg-6 col-md-10 col-12 inv"
        ref={contentRef}
      >
        <div className="invoice-container">
          <div className="d-flex align-items-center mr-1">
            <img
              src={clientDetails.image}
              alt=""
              style={{
                height: "90px",
                width: "90px",
                marginRight: "15px",
                marginLeft: "40px",
              }}
            />
            <div className="invoice-header">
              <h2 style={{ fontSize: "30px" }}>
                {clientDetails.business_name.toUpperCase()}
              </h2>
              {clientDetails.tagline && (
                <p>{clientDetails.tagline.toUpperCase()}</p>
              )}
              <p>{clientDetails.address.toUpperCase()}</p>
              <p style={{ fontSize: "15.5px" }}>
                Contacts: {clientDetails.contact}
              </p>
              {clientDetails.email && (
                <p style={{ fontSize: "14px", marginBottom: "8px" }}>
                  {clientDetails.email}
                </p>
              )}
              <h2 style={{ fontSize: "18px" }}>{hotelDetail.gstin_show == '1' ? 'TAX INVOICE' : 'INVOICE'}</h2>
            </div>
          </div>

          <div className="invoice-details">
            <div className="registrations">
                              {hotelDetail.gstin_show == '1' ?
              clientDetails.gstin !== null && (
                <p>GSTIN: {clientDetails.gstin}</p>
              ): (<p></p>)
            }
              {clientDetails.fssai !== null && clientDetails.fssai && (
                <p>FSSAI No.: {clientDetails.fssai}</p>
              )}
              {clientDetails.oyo_reg !== null && clientDetails.oyo_reg && (
                <p>OYO Reg No.: {clientDetails.oyo_reg}</p>
              )}
            </div>
            <div className="client-details">
              <div className="invoice-meta text-start">
                <p>
                  Company Name: <b>{guestData.is_com ? guestData.name : ""}</b>
                </p>
                <p>Company GST: {guestData.is_com ? guestData.contact : ""}</p>
                <p>
                  Guest Name:&nbsp;
                  <b>
                    {guestData.is_com ? guestData.guest_name : guestData.name}
                  </b>
                </p>
                <p>
                  Guest Contact:{" "}
                  {guestData.is_com
                    ? guestData.comp_contact
                    : guestData.contact}
                </p>
                {clientDetails.id === 6 && (
                  <p style={{ height: "42px" }}>Address: {guestData.address}</p>
                )}
              </div>
              <div className="invoice-meta text-start">
                <p>
                  Invoice No:{" "}
                  {props.multiBills && props.multiBills.length > 1
                    ? props.multiBills[0].inv_no < 10
                      ? `00${props.multiBills[0].inv_no}`
                      : props.multiBills[0].inv_no < 100
                      ? `0${props.multiBills[0].inv_no}`
                      : props.multiBills[0].inv_no
                    : props.invoiceDetails.inv_no < 10
                    ? `00${props.invoiceDetails.inv_no}`
                    : props.invoiceDetails.inv_no < 100
                    ? `0${props.invoiceDetails.inv_no}`
                    : props.invoiceDetails.inv_no}
 &nbsp;&nbsp;|&nbsp; FY&nbsp;
  {
    (() => {
      const year = parseInt(props.invoiceDetails.to_date.slice(0, 4));
      const month = parseInt(props.invoiceDetails.to_date.slice(5, 7));
      const fyStart = month < 4 ? year - 1 : year;
      const fyEnd = fyStart + 1;
      return `${fyStart.toString().slice(-2)}-${fyEnd.toString().slice(-2)}`;
    })()
  }                </p>
                {clientDetails.id === 6 && (
                  <p>
                    Entry No:&nbsp;&nbsp;
                    {props.invoiceDetails.remarks}
                  </p>
                )}
                <p>
                  Room No:{" "}
                  {props.multiBills && props.multiBills.length > 1
                    ? props.multiBills.map((b) => b.room_no).join(", ")
                    : props.invoiceDetails.room_no}
                </p>
                <b>
                  <p>
                    Checkin: &nbsp;&nbsp;&nbsp;
                    {props.invoiceDetails.from_date.slice(8, 10)}-
                    {props.invoiceDetails.from_date.slice(5, 7)}-
                    {props.invoiceDetails.from_date.slice(0, 4)}{" "}
                    {props.invoiceDetails.from_date.slice(11, 16)}
                  </p>
                </b>
                <b>
                  <p>
                    Checkout: {props.invoiceDetails.to_date.slice(8, 10)}-
                    {props.invoiceDetails.to_date.slice(5, 7)}-
                    {props.invoiceDetails.to_date.slice(0, 4)}{" "}
                    {props.invoiceDetails.to_date.slice(11, 16)}
                  </p>
                </b>
              </div>
            </div>
            {clientDetails.id !== 6 && (
              <div style={{ height: "48px" }}>
                <p className="address-line">Address: {guestData.address}</p>
              </div>
            )}
            <div
              style={{
                height: "380px",
                borderBottom: "1px solid #000000",
                position: "relative",
              }}
            >
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  backgroundImage: `url(${clientDetails.image})`,
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "center",
                  backgroundSize: "270px",
                  opacity: 0.2, // Sets only the background opacity
                  zIndex: 0, // Ensure it's behind the content
                }}
              ></div>
              <table className="invoice-table">
                <thead style={{ backgroundColor: "#1111" }}>
                  <tr>
                    <th style={rowOne}>S.No.</th>
                    <th style={rowTwo}>Particulars</th>
                    <th style={rowThree}>Rent/Day</th>
                    <th style={rowOne}>Days</th>
                    <th style={rowFour}>Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {props.multiBills && props.multiBills.length > 1 ? (
                    <>
                      {props.multiBills.map((bill, index) => (
                        <tr key={index}>
                          <td style={rowOne}>{index + 1}</td>
                          <td style={rowTwo}>
                            Room ({getRoomTypeById(bill.room_id)})
                          </td>
                          <td style={rowThree}>
                            ₹{" "}
                            {hotelDetail.gstin_show == '1' ?                             (
                              parseFloat(bill.total_amount) /
                              calculateDaysDifference(
                                bill.from_date,
                                bill.to_date
                              )
                            ).toFixed(2):
                            (
                              parseFloat(bill.total_amount) + parseFloat(bill.tax_amount) /
                              calculateDaysDifference(
                                bill.from_date,
                                bill.to_date
                              )
                            ).toFixed(2)
                            }

                          </td>
                          <td style={rowOne}>
                            {calculateDaysDifference(
                              bill.from_date,
                              bill.to_date
                            )}
                          </td>
                          <td style={rowFour}>₹ {bill.total_amount}</td>
                        </tr>
                      ))}
                    </>
                  ) : (
                    <tr>
                      <td style={rowOne}>1</td>
                      <td style={rowTwo}>
                        Room ({getRoomTypeById(props.invoiceDetails.room_id)})
                      </td>
                      <td style={rowThree}>
                        ₹{" "}
                                                    {hotelDetail.gstin_show == '1' ?                             (
                              parseFloat(props.invoiceDetails.total_amount) /
                              calculateDaysDifference(
                                props.invoiceDetails.from_date,
                                props.invoiceDetails.to_date
                              )
                            ).toFixed(2):
                            (
                              parseFloat(props.invoiceDetails.total_amount) + parseFloat(props.invoiceDetails.tax_amount) /
                              calculateDaysDifference(
                                props.invoiceDetails.from_date,
                                props.invoiceDetails.to_date
                              )
                            ).toFixed(2)
                            }
                        {/* {(
                          parseFloat(props.invoiceDetails.total_amount) /
                          calculateDaysDifference(
                            props.invoiceDetails.from_date,
                            props.invoiceDetails.to_date
                          )
                        ).toFixed(2)} */}
                      </td>
                      <td style={rowOne}>
                        {calculateDaysDifference(
                          props.invoiceDetails.from_date,
                          props.invoiceDetails.to_date
                        )}
                      </td>
                      <td style={rowFour}>
                        ₹ 
                        {hotelDetail.gstin_show == '1' ? props.invoiceDetails.total_amount :
                        (parseFloat(props.invoiceDetails.total_amount) + parseFloat(props.invoiceDetails.tax_amount))}
                        {/* {props.invoiceDetails.total_amount} */}
                      </td>
                    </tr>
                  )}
                  {/* {props.invoiceDetails.tax_amount > 0 && (
                    <tr>
                      <td style={rowOne}>2</td>
                      <td style={rowTwo}>
                        ROOM GST @{props.invoiceDetails.tax_rate}%
                      </td>
                      <td style={rowThree}>
                        ₹ {props.invoiceDetails.tax_amount}
                      </td>
                    </tr>
                  )} */}
                  {props.printFood &&
                    parseFloat(props.invoiceDetails.food_price) > 0 && (
                      <tr>
                        {props.multiBills && props.multiBills.length > 1 ? (
                          <td style={rowOne}>{props.multiBills.length + 1}</td>
                        ) : (
                          <td style={rowOne}>2</td>
                        )}
                        <td style={rowTwo}>Food Bill</td>
                        <td style={rowThree}></td>
                        <td style={rowOne}></td>
                        <td style={rowFour}>
                          ₹ {props.invoiceDetails.food_price}
                        </td>
                      </tr>
                    )}
                  {/* {props.printFood &&
                    parseFloat(props.invoiceDetails.food_tax_amount) > 0 && (
                      <tr>
                        <td style={rowOne}>2</td>
                        <td style={rowTwo}>
                          Food GST @{props.invoiceDetails.food_tax_rate}%
                        </td>
                        <td style={rowThree}>
                          ₹ {props.invoiceDetails.food_tax_amount}
                        </td>
                      </tr>
                    )} */}
                  {props.printExtra && (
                    <tr>
                      <td style={rowOne}>
                        {props.multiBills && props.multiBills.length > 1 ? (
                          <td style={rowOne}>{props.multiBills.length + 2}</td>
                        ) : props.printFood &&
                          parseFloat(props.invoiceDetails.food_price) > 0 ? (
                          "3"
                        ) : (
                          "2"
                        )}
                      </td>
                      <td style={rowTwo}>Extra Charges</td>
                      <td style={rowThree}></td>
                      <td style={rowOne}></td>
                      <td style={rowFour}>
                        ₹ {props.invoiceDetails.extra_charges}
                      </td>
                    </tr>
                  )}
                  {parseFloat(props.invoiceDetails.discount) > 0 && (
                    <tr>
                      <td style={rowOne}>
                        {props.multiBills && props.multiBills.length > 1 ? (
                          <td style={rowOne}>{props.multiBills.length + 3}</td>
                        ) : props.printFood &&
                          parseFloat(props.invoiceDetails.food_price) > 0 ? (
                          props.printExtra ? (
                            "4"
                          ) : (
                            "3"
                          )
                        ) : props.printExtra ? (
                          "3"
                        ) : (
                          "2"
                        )}
                      </td>
                      <td style={rowTwo}>Discount</td>
                      <td style={rowThree}></td>
                      <td style={rowOne}></td>
                      <td style={rowFour}>₹ {props.invoiceDetails.discount}</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            <div className="total-details">
              <div className="invoice-total" style={{ textAlign: "left" }}>
                {/* <p>
                  Total Days of Stay:{" "}
                  {calculateDaysDifference(
                    props.invoiceDetails.from_date,
                    props.invoiceDetails.to_date
                  )}{" "}
                  X{" "}
                  {props.multiBills && props.multiBills.length > 1
                    ? (
                        sumof(
                          props.multiBills.map((bill) => bill.total_amount)
                        ) /
                        calculateDaysDifference(
                          props.invoiceDetails.from_date,
                          props.invoiceDetails.to_date
                        )
                      ).toFixed(2)
                    : (
                        parseFloat(props.invoiceDetails.total_amount) /
                        calculateDaysDifference(
                          props.invoiceDetails.from_date,
                          props.invoiceDetails.to_date
                        )
                      ).toFixed(2)}
                </p> */}
                <p>
                  Total No. of Adults&nbsp;:{" "}
                  {props.multiBills && props.multiBills.length > 1
                    ? props.multiBills.reduce(
                        (sum, b) => sum + parseInt(b.no_of_stayers),
                        0
                      )
                    : props.invoiceDetails.no_of_stayers}
                </p>
                {parseFloat(props.invoiceDetails.advance_amount) > 0 && (
                  <p>
                    Advance Amount Paid&nbsp;&nbsp;: ₹{" "}
                    {props.invoiceDetails.advance_amount}
                  </p>
                )}
              </div>
              <div
                className="invoice-total"
                style={{
                  height:
                    props.printFood &&
                    parseFloat(props.invoiceDetails.food_tax_amount) > 0
                      ? "100px"
                      : "60px",
                }}
              >
                <table className="invoice-total-table">
                  <tbody>
                    <tr>
                      <th className="label">{hotelDetail.gstin_show == '1' ? 'Gross Total' : 'Grand Total'}</th>
                      <th className="value">
                        ₹{" "}

{hotelDetail.gstin_show == '1' ? 
                                        (
                          parseFloat(props.invoiceDetails.total_amount) -
                          parseFloat(props.invoiceDetails.discount) +
                          (props.printExtra
                            ? parseFloat(props.invoiceDetails.extra_charges)
                            : 0) +
                          (props.printFood
                            ? parseFloat(props.invoiceDetails.food_price)
                            : 0)
                        ).toFixed(2)

                :
                        (
                  parseFloat(props.invoiceDetails.total_amount) -
                  parseFloat(props.invoiceDetails.discount) +
                  (props.printExtra
                    ? parseFloat(props.invoiceDetails.extra_charges)
                    : 0) +
                  (props.printFood
                    ? parseFloat(props.invoiceDetails.food_price)
                    : 0) +
                  (props.printFood
                    ? parseFloat(props.invoiceDetails.food_tax_amount)
                    : 0) +
                  parseFloat(props.invoiceDetails.tax_amount)
                ).toFixed(0)
              }
                        {/* {(
                          parseFloat(props.invoiceDetails.total_amount) -
                          parseFloat(props.invoiceDetails.discount) +
                          (props.printExtra
                            ? parseFloat(props.invoiceDetails.extra_charges)
                            : 0) +
                          (props.printFood
                            ? parseFloat(props.invoiceDetails.food_price)
                            : 0)
                        ).toFixed(2)} */}
                      </th>
                    </tr>


{hotelDetail.gstin_show == '1' &&  parseFloat(props.invoiceDetails.tax_amount) > 0 && (
                      <>
                        <tr>
                          <td className="label">
                            Room SGST @
                            {(
                              parseFloat(props.invoiceDetails.tax_rate) / 2
                            ).toFixed(2)}
                            %
                          </td>
                          <td className="value">
                            ₹{" "}
                            {(
                              parseFloat(props.invoiceDetails.tax_amount) / 2
                            ).toFixed(2)}
                          </td>
                        </tr>
                        <tr>
                          <td className="label">
                            Room CGST @
                            {(
                              parseFloat(props.invoiceDetails.tax_rate) / 2
                            ).toFixed(2)}
                            %
                          </td>
                          <td className="value">
                            ₹{" "}
                            {(
                              parseFloat(props.invoiceDetails.tax_amount) / 2
                            ).toFixed(2)}
                          </td>
                        </tr>
                      </>
                    )
                  }


                    {hotelDetail.gstin_show == '1' && props.printFood &&
                      parseFloat(props.invoiceDetails.food_tax_amount) > 0 && (
                        <>
                          <tr>
                            <td className="label">
                              Food SGST @
                              {(
                                parseFloat(props.invoiceDetails.food_tax_rate) /
                                2
                              ).toFixed(2)}
                              %
                            </td>
                            <td className="value">
                              ₹{" "}
                              {(
                                parseFloat(
                                  props.invoiceDetails.food_tax_amount
                                ) / 2
                              ).toFixed(2)}
                            </td>
                          </tr>
                          <tr>
                            <td
                              className="label"
                              style={{ borderBottom: "none" }}
                            >
                              Food CGST @
                              {(
                                parseFloat(props.invoiceDetails.food_tax_rate) /
                                2
                              ).toFixed(2)}
                              %
                            </td>
                            <td
                              className="value"
                              style={{ borderBottom: "none" }}
                            >
                              ₹{" "}
                              {(
                                parseFloat(
                                  props.invoiceDetails.food_tax_amount
                                ) / 2
                              ).toFixed(2)}
                            </td>
                          </tr>
                        </>
                      )}
                  </tbody>
                </table>
              </div>
            </div>
            {/* <div
              // style={{ height: "25px", justifyContent: "space-between" }}
              style={{ justifyContent: "space-between" }}
              className="invoice-total d-flex"
            > */}
<p style={{
  display: "flex",
  justifyContent: "space-between",
  padding: "0px 5px",
  margin: 0,
  borderBottom: "1px solid #000"
}}>
  <span style={{ flex: "1 1 auto" }}>
Payment Mode: {props.invoiceDetails.payment_method
  ? props.invoiceDetails.payment_method.includes(" | ")
    ? props.invoiceDetails.payment_method.split(" | ")[0]
    : props.invoiceDetails.payment_method
  : "Pending"}
    {/* Payment Mode: {props.invoiceDetails.payment_method.includes(" | ") 
      ? props.invoiceDetails.payment_method.split(" | ")[0]
      : props.invoiceDetails.payment_method} */}
  </span>

  {props.invoiceDetails.payment_method.includes(" | ") && (
    <div
      style={{
        borderLeft: '1px solid',
        paddingLeft: "5px",
        fontSize: '0.8em',
        display: "inline-block",
        minWidth: "196px",
        verticalAlign: "top",
      }}
    >
      {props.invoiceDetails.payment_method
        .split(" | ")
        .slice(1)
        .map((item, i) => {
          const [method, amount] = item.split("-");
          return (
            <div
              key={i}
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginBottom: "2px",
              }}
            >
              <span>{method}</span>
              <span>₹{amount}</span>
            </div>
          );
        })}
        </div>
        )}
</p>

              {hotelDetail.gstin_show == '1' ? 
              <p style={{ fontWeight: "600", margin: 0, padding: '5px', textAlign: 'end' }}>
                Grand Total:&nbsp;&nbsp; ₹&nbsp;
                {(
                  parseFloat(props.invoiceDetails.total_amount) -
                  parseFloat(props.invoiceDetails.discount) +
                  (props.printExtra
                    ? parseFloat(props.invoiceDetails.extra_charges)
                    : 0) +
                  (props.printFood
                    ? parseFloat(props.invoiceDetails.food_price)
                    : 0) +
                  (props.printFood
                    ? parseFloat(props.invoiceDetails.food_tax_amount)
                    : 0) +
                  parseFloat(props.invoiceDetails.tax_amount)
                ).toFixed(0)}
                .00
              </p> : <p></p>}
            {/* </div> */}
            <p
              style={{
                fontSize: "14px",
                margin: "0",
                padding: "0 5px",
                borderBottom: "1px solid #000000",
              }}
            >
              Amount in words:{" "}
              {convertAmountToWords(
                parseFloat(props.invoiceDetails.total_amount) -
                  parseFloat(props.invoiceDetails.discount) +
                  (props.printExtra
                    ? parseFloat(props.invoiceDetails.extra_charges)
                    : 0) +
                  (props.printFood
                    ? parseFloat(props.invoiceDetails.food_price)
                    : 0) +
                  (props.printFood
                    ? parseFloat(props.invoiceDetails.food_tax_amount)
                    : 0) +
                  parseFloat(props.invoiceDetails.tax_amount)
              )}
            </p>
            {props.printRemarks && (
              <pre
                style={{
                  fontWeight: "400",
                  margin: "0 5px",
                }}
              >
                Remarks: {props.invoiceDetails.remarks}
              </pre>
            )}
            <div className="footer-data">
              <div className="left-foot" style={{ paddingBottom: "5px 0" }}>
                <strong style={{ textAlign: "start" }}>
                  <pre style={{ margin: "0", fontSize: "12px" }}>
                    {clientDetails.footer_contents}
                  </pre>
                </strong>
                <p
                  style={{
                    marginTop: "30px",
                    marginLeft: "25px",
                  }}
                >
                  Customer Signature
                </p>
              </div>
              <div className="right-foot">
                <p>For {clientDetails.business_name}</p>
                {clientDetails.sign_image && (
                  <img
                    src={clientDetails.sign_image}
                    alt="Signature"
                    height={"80px"}
                    width={"140px"}
                  />
                )}
                <p>Authorised Signature</p>
              </div>
            </div>
            <p
              style={{
                textAlign: "center",
                fontWeight: "500",
                marginBottom: "2px",
              }}
            >
              !! Thank you for your stay !!
            </p>
          </div>

          {/* Print Button */}
        </div>
      </div>
      <br />

<div>
      <button className="print-btn me-2" onClick={reactToPrintFn}>
        Print Invoice
      </button>
      <button className="print-btn" onClick={sendInvoiceEmail}>
  Send via Email
</button>
</div>


    </section>
  );
}

export default InvoicePage;
